import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import grafico from '../images/grafico.png';

const Fichaprojeto = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [concluido, setConcluido] = useState([]);
  const [emandamento, setEmandamento] = useState([]);
  const [naoiniciado, setNaoiniciado] = useState([]);
  const [atrasado, setAtrasado] = useState([]);

  const [selecionados, setSelecionados] = useState(new Set());

  
  useEffect(() => {
    axios
      .get('/api/projetocompleto')
      .then((res) => {
        if (res.data.Status === 'Success') {
          setData(res.data.Result);
          setFilteredData(res.data.Result);
        } else {
          alert('Erro ao buscar projetos');
        }
      })
      .catch((err) => console.log(err));
  }, []);

  
  useEffect(() => {
    axios
      .get('/api/getconcluido')
      .then((res) => setConcluido(res.data[0].concluido))
      .catch((err) => console.log(err));

    axios
      .get('/api/getemandamento')
      .then((res) => setEmandamento(res.data[0].emandamento))
      .catch((err) => console.log(err));

    axios
      .get('/api/getnaoiniciado')
      .then((res) => setNaoiniciado(res.data[0].naoiniciado))
      .catch((err) => console.log(err));

    axios
      .get('/api/getatrasado')
      .then((res) => setAtrasado(res.data[0].atrasado))
      .catch((err) => console.log(err));
  }, []);

  
  const search = (e) => {
    const query = e.target.value.toLowerCase();
    setFilteredData(
      data.filter(
        (item) =>
          item.nomeprojeto.toLowerCase().includes(query) ||
          item.secretaria.toLowerCase().includes(query)
      )
    );
  };

  
  const toggleSelecionado = (id) => {
    setSelecionados((prev) => {
      const novo = new Set(prev);
      if (novo.has(id)) {
        novo.delete(id);
      } else {
        novo.add(id);
      }
      return novo;
    });
  };

  
  const gerarPDF = async () => {
    if (selecionados.size === 0) {
      alert('Selecione pelo menos um projeto para gerar o PDF.');
      return;
    }

    const idsArray = Array.from(selecionados);

    try {
      const response = await axios.post(
        '/api/gerar-pdf',
        { ids: idsArray },
        { responseType: 'blob' } // importante para receber o arquivo
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'projetos.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      alert('Erro ao gerar PDF');
    }
  };

  return (
    <div className="px-5 py-3">
      <div className="d-flex justify-content-center mt-2">
        <h3>Ficha do PROJETO</h3>
      </div>

      <Link to="/employee" className="btn btn-info px-5 g-5 me-2">
        Retorna projeto
      </Link>
      <button className="btn btn-success" onClick={gerarPDF}>
        Gerar PDF ({selecionados.size} selecionados)
      </button>
      <div className="main-cards">
        <div className="card">
          <div className="card-inner">
            <h3>CONCLUÍDO</h3>
            <img src={grafico} alt="" className="usuario" />
          </div>
          <h1> Total: {concluido}</h1>
        </div>

        <div className="card">
          <div className="card-inner">
            <h3>EM ANDAMENTO</h3>
            <img src={grafico} alt="" className="usuario" />
          </div>
          <h1> Total: {emandamento}</h1>
        </div>

        <div className="card">
          <div className="card-inner">
            <h3>NÃO INICIADO</h3>
            <img src={grafico} alt="" className="usuario" />
          </div>
          <h1> Total: {naoiniciado}</h1>
        </div>

        <div className="card">
          <div className="card-inner">
            <h3>ATRASADO</h3>
            <img src={grafico} alt="" className="usuario" />
          </div>
          <h1> Total: {atrasado}</h1>
        </div>
      </div>

      <div className="mt-3">
        <div className="input-group mb-2 col">
          <span className="input-group-text bg-primary text-white">
            Pesquisa estruturada
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Pesquisar nome do projeto"
            autoComplete="off"
            onKeyUp={search}
          />
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>Selecionar</th>
              <th>Secretaria</th>
              <th>Projeto</th>
              <th>Data Início</th>
              <th>Data Fim</th>
              <th>Situação</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    checked={selecionados.has(item.id)}
                    onChange={() => toggleSelecionado(item.id)}
                  />
                </td>
                <td>{item.secretaria}</td>
                <td>{item.nomeprojeto}</td>
                <td>{new Date(item.datainicioetapa1).toLocaleDateString('pt-BR')}</td>
                <td>{new Date(item.datafimetapa6).toLocaleDateString('pt-BR')}</td>
                <td>{item.situacaoetapa1}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Fichaprojeto;
